export const Dates = {
	methods: {
		getDayOfWeek(date) {
			// console.log("date", date);
			var dayOfWeek = new Date(date).getDay();
			// console.log("dayof week", dayOfWeek);
			return isNaN(dayOfWeek)
				? null
				: [
						"Monday",
						"Tuesday",
						"Wednesday",
						"Thursday",
						"Friday",
						"Saturday",
						"Sunday"
				  ][dayOfWeek - 1];
		},
		getMonthOfYear(date) {
			var monthOfYear = new Date(date).getMonth();
			return isNaN(monthOfYear)
				? null
				: [
						"January",
						"February",
						"March",
						"April",
						"May",
						"June",
						"July",
						"August",
						"September",
						"October",
						"November",
						"Decemember"
				  ][monthOfYear];
		},
		getDayOfMonth(date) {
			return new Date(date).getUTCDate();
		},
		getFullYear(date) {
			return new Date(date).getUTCFullYear();
		},
		ordinal(n) {
			var o = ["th", "st", "nd", "rd"],
				x = n % 100;
			return x + (o[(x - 20) % 10] || o[x] || o[0]);
		},
		currentDateDDMMYYYY() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();

			if (dd < 10) {
				dd = "0" + dd;
			}

			if (mm < 10) {
				mm = "0" + mm;
			}

			today = dd + "-" + mm + "-" + yyyy;
			return today;
		},
		currentDateYYYYMMDD() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();

			if (dd < 10) {
				dd = "0" + dd;
			}

			if (mm < 10) {
				mm = "0" + mm;
			}

			today = yyyy + "-" + mm + "-" + dd;
			return today;
			// console.log("today", today);
		}
	}
};
